<loading [visible]="saving()"></loading>

@if(!loading()){
<form [formGroup]="saveForm" (ngSubmit)="saveEntity()"
  class="grid grid-cols-1 md:grid-cols-12 gap-6 max-h-[calc(100vh-150px)]">

  <div
    class="md:col-span-12 flex flex-col md:flex-row justify-between items-center border-b-2 border-black pb-4 h-fit gap-4">

    <span class="text-xl font-black text-black uppercase tracking-[0.2em]">Venta de crédito</span>

    <div class="flex flex-wrap gap-4 items-end">
      <div class="w-32">
        <custom-input label="Año" type="number" [formControlItem]="saveForm.get('year')"></custom-input>
      </div>
      <div class="w-44">
        <custom-input label="Fecha" type="date" [formControlItem]="saveForm.get('date')"></custom-input>
      </div>
      <div class="w-56">
        <label class="block mb-2 text-[10px] font-black text-black uppercase tracking-widest">Vendedor</label>
        <select formControlName="user_id"
          class="w-full px-2 py-1 text-sm border border-black rounded-xl bg-white font-bold focus:ring-2 focus:ring-black/5">
          <option [value]="null">Seleccionar...</option>
          @for(user of dropdowns.users; track user.id){ <option [value]="user.id">{{ user.name }}</option> }
        </select>
      </div>
      @if (dropdowns.offices.length) {
      <div class="w-56">
        <label class="block mb-2 text-[10px] font-black text-black uppercase tracking-widest">Oficina</label>
        <select formControlName="office_id"
          class="w-full px-2 py-1 text-sm border border-black rounded-xl bg-white font-bold focus:ring-2 focus:ring-black/5">
          @for(office of dropdowns.offices; track office.id){ <option [value]="office.id">{{ office.name }}</option> }
        </select>
      </div>
      }
    </div>
  </div>
  <div class="md:col-span-12 flex flex-col md:flex-row items-center border-b-2 border-black pb-4 h-fit gap-4">
  <div class="bg-white border border-black rounded-xl px-2 py-1 text-sm font-bold">
        <label for="date_start" >Fecha desde: </label>
        <input type="date" id="date_start" name="date_start" (change)="onDateStartChange($event.target.value)">
    </div>
    <div class="bg-white border border-black rounded-xl px-2 py-1 text-sm font-bold">
        <label for="date_end" >Fecha hasta: </label>
        <input type="date" id="date_end" name="date_end" (change)="onDateEndChange($event.target.value)">
    </div>
    <button type="button" (click)="dateFilter()" class="cursor-pointer px-6 py-2.5 text-sm font-medium text-black bg-white border border-black focus:outline-none focus:ring-2 focus:ring-blue-300 rounded-lg transition-all duration-200">Filtrar</button>
  </div>

  <div class="md:col-span-4 space-y-6 overflow-y-auto pr-2 custom-scroll">
    <section class="bg-white p-3 rounded-xl border border-black space-y-4">
      
      <custom-select [autofocus]="true" label="Cliente" [formControlItem]="saveForm.controls['client_id']"
        [options]="dropdowns.clients" bindValue="id" bindLabel="name" bindSubLabel="nif" [isMultiple]="false"
        placeholder="Selecciona un cliente" (selectionChange)="changeClient()">
      </custom-select>

      <custom-select label="Método de pago" [formControlItem]="saveForm.controls['pay_id']"
        [options]="dropdowns.payMethods" bindValue="id" bindLabel="name" [isMultiple]="false"
        placeholder="Selecciona un método de pago" (selectionChange)="changePayMethod()">
      </custom-select>

      <div class="flex flex-col gap-2">
        <!-- <div class="flex items-center group cursor-pointer">
                    <input type="checkbox" id="invoice_credit_bool" formControlName="invoice_credit_bool"
                        class="w-5 h-5 text-black border border-black rounded focus:ring-black accent-black cursor-pointer">
                    <label for="invoice_credit_bool" class="ml-3 text-sm font-bold text-black cursor-pointer">
                        Partir en varias facturas
                    </label>
                </div> -->

        <!-- @if (saveForm.get('invoice_credit_bool')?.value && saveForm.get('invoice_split')?.value?.length > 0) { -->
        @if (saveForm.get('invoice_split')?.value?.length > 0) {
        <div class="mt-2 space-y-2">
          <div class="flex font-bold text-xs text-black/60">
            <div class="w-32">Fecha</div>
            <div class="w-20">%</div>
            <div class="w-24">Subtotal</div>
            <div class="w-24">Total</div>
          </div>
          <div formArrayName="invoice_split">
            @for (item of invoiceSplitArray.controls; track $index) {
            <div [formGroupName]="$index"
              class="flex items-center text-xs font-mono bg-neutral-100 rounded-lg px-2 py-1 gap-2">
              <div class="w-32">
                <input type="date" formControlName="date" class="w-full px-2 py-1 rounded border border-black" />
              </div>
              <div class="w-20">
                <input type="text" inputmode="decimal" decimalInput formControlName="percent"
                  class="w-full px-2 py-1 rounded border border-black text-right" />
              </div>
              <div class="w-24">
                <input type="text" formControlName="subtotal"
                  class="w-full px-2 py-1 rounded border border-black text-right bg-gray-100" readonly />
              </div>
              <div class="w-24">
                <input type="text" formControlName="total"
                  class="w-full px-2 py-1 rounded border border-black text-right bg-gray-100" readonly />
              </div>
            </div>
            }
          </div>
        </div>
        }
      </div>
    </section>

    <div [class.opacity-50]="!isClientSelected" [class.pointer-events-none]="!isClientSelected"
      class="bg-black rounded-xl p-4 text-white">
      <div class="space-y-2">
        <div class="flex justify-between text-neutral-400 font-black uppercase text-[10px] tracking-widest">
          <span>Subtotal</span>
          <span [centToEurDisplay]="saveForm.get('subtotal')?.value"><span class="text-xs ml-0.5">€</span></span>
        </div>

        <div class="flex justify-between items-center bg-white/10 p-2 rounded-2xl border border-white/20">
          <div class="flex bg-black p-1 rounded-lg border border-white/20">
            <label class="cursor-pointer">
              <input type="radio" [value]="0" formControlName="discount_absolute_bool" class="peer hidden">
              <span
                class="px-3 py-1 rounded-md text-[10px] font-black text-neutral-400 peer-checked:bg-white peer-checked:text-black transition-all">%</span>
            </label>
            <label class="cursor-pointer">
              <input type="radio" [value]="1" formControlName="discount_absolute_bool" class="peer hidden">
              <span
                class="px-3 py-1 rounded-md text-[10px] font-black text-neutral-400 peer-checked:bg-white peer-checked:text-black transition-all">€</span>
            </label>
          </div>
          <input type="text" inputmode="decimal" decimalInput formControlName="discount"
            class="w-24 bg-transparent border-none text-right font-black text-white focus:ring-0 p-0 text-xl"
            placeholder="0">
        </div>

        <div class="flex items-center justify-end gap-2">
          <label for="irpf_bool" class="text-[10px] font-black text-neutral-400 uppercase tracking-widest cursor-pointer">IRPF
            (5,2%)</label>
          <input type="checkbox" id="irpf_bool" formControlName="irpf_bool"
            class="w-5 h-5 text-black border border-white/20 rounded focus:ring-black accent-white cursor-pointer">
        </div>

        <div class="pt-2 flex justify-between items-end border-t border-white/20">
          <span class="text-xs font-bold text-neutral-400 uppercase tracking-tighter">Total a pagar</span>
          <span class="text-5xl font-black" [centToEurDisplay]="saveForm.get('total')?.value"><span
              class="text-xl ml-1 text-neutral-400">€</span></span>
        </div>

        <button type="submit" [disabled]="saveForm.invalid || saving()"
          class="w-full py-2 bg-white text-black hover:bg-neutral-200 rounded-2xl font-black text-xs tracking-[0.2em] transition-all uppercase">
          Guardar Documento
        </button>
        <button type="button" (click)="saveAndPrint()" [disabled]="saveForm.invalid || saving()"
          class="w-full py-2 bg-white text-black hover:bg-neutral-200 rounded-2xl font-black text-xs tracking-[0.2em] transition-all uppercase">
          Imprimir
        </button>
      </div>
    </div>
  </div>

  <div [class.opacity-50]="!isClientSelected" [class.pointer-events-none]="!isClientSelected"
    class="md:col-span-8 flex flex-col row-span-8 h-full bg-white rounded-xl border border-black shadow-sm overflow-hidden">
    <div class="p-3 border-b-2 border-black">
      <div class="relative">
        <input type="text" #mainSearch (input)="filterDeliveryNotes($any($event.target).value)"
          (focus)="showResults = true" placeholder="BUSCAR ALBARÁN POR FECHA"
          class="w-full px-4 py-3 bg-neutral-50 border border-black rounded-2xl focus:ring-4 focus:ring-black/5 text-sm font-black pl-14 uppercase tracking-widest">
        <span class="absolute left-4 top-2 text-xl">🔍</span>

        @if(showResults && show_list.length > 0) {
        <div
          class="absolute z-50 w-full mt-2 bg-white border border-black rounded-3xl shadow-2xl max-h-60 overflow-y-auto p-2">
          @for(note of show_list; track note) {
          <button type="button" (click)="selectDeliveryNoteFromSearch(note, mainSearch)"
            class="w-full flex items-center justify-between p-4 hover:bg-black hover:text-white rounded-xl text-left transition-colors group">
            <div class="flex flex-col">
              <span class="text-sm font-black uppercase">Albarán {{ note.code }}</span>
              <span class="text-[10px] font-bold opacity-50">{{note.date_string}}</span>
            </div>
            <span class="text-sm font-black" [centToEurDisplay]="note.price"></span>
          </button>
          }
        </div>
        }
      </div>
    </div>

    <div class="flex-1 overflow-y-auto custom-scroll">
      <table class="w-full text-left border-collapse">
        <thead class="sticky top-0 bg-black text-white z-10">
          <tr>
            <th class="px-6 py-4 text-[10px] font-black uppercase tracking-widest">
              Producto
            </th>
            <th class="px-4 py-4 text-[10px] font-black uppercase tracking-widest text-right w-32">
              Total
            </th>
            <th class="w-16"></th>
          </tr>
        </thead>
        <tbody formArrayName="items" class="divide-y divide-neutral-100">
          @for (item of itemControls; track item; let i = $index) {
              
          <tr [formGroupName]="i" class="hover:bg-neutral-50 transition-colors">
            <td class="px-6 py-4">           
              <div class="flex flex-col">
                <span class="text-sm font-black text-black uppercase">
                  {{'Albarán ' + item.get('code')?.value || 'Albarán' }}
                </span>
                <span class="text-[10px] text-neutral-400 font-mono font-bold tracking-tighter">
                  {{ item.get('date_string')?.value || 'S/N' }}
                </span>
              </div>
            </td>
            <td class="px-4 py-4 text-right font-mono font-black text-black text-sm"
              [centToEurDisplay]="item.get('price')?.value">
            </td>
            <td class="px-4 py-4 text-center">
              <button type="button" (click)="removeItem(i)"
                class="w-8 h-8 flex items-center justify-center rounded-full text-neutral-300 hover:bg-black hover:text-white transition-all">
                ✕
              </button>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>

    <div class="p-3 bg-neutral-50 border-t-2 border-black">
      <label class="block text-[10px] font-black text-black uppercase tracking-widest mb-2 ml-1">
        Notas
      </label>
      <textarea tabindex="-1" formControlName="notes" rows="2"
        class="w-full p-4 bg-white border border-black rounded-2xl text-xs font-bold resize-none focus:outline-none focus:ring-4 focus:ring-black/5"
        placeholder="Escribe notas internas o comentarios para el cliente..."></textarea>
    </div>
  </div>
</form>
}